import React, {Component} from 'react';
import {roundigFormat} from '../libs/utils/Operations';
import moment from 'moment';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action) => {
    let body: "";

    body = data.map((register, index) => {

        return (
            <tr key={index}>
                <td>{register.Code || ""}</td>
                <td>{register.Name || ""}</td>
                <td style={{textAlign:"center", width:100}}>
                    <button type="button" className="btn btn-sm "
                            onClick={() => action({index})}
                            style={{fontWeight: '500', backgroundColor: "transparent", color: "#EABF28"}}>
                        <i className="fas fa-check"></i>
                    </button>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action) => {
    let header = "";
    let body = "";

    if (headers.length != 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow " style={{width:100}}></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{width: '100%'}}>
                <thead className="table-header">
                {header}
                </thead>
                <tbody>
                {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderDepartmentsModal = (headers, data, action) => {

    return renderTable(headers, data, action);

}
